var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"competitors-configuration-page"}},[_c('div',{staticClass:"vx-row"},[_c('div',{staticClass:"vx-col w-full md:w-1/2 lg:w-1/2 xl:w-1/2 mb-base"},[_c('competition-configuration')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }